import React, { Dispatch } from 'react'
import { connect } from 'react-redux'
import { AppState } from '../../../../store';
import { thunkLogInWithPopup, thunkLogOut } from '../../../../modules/auth'


interface LoginComponentStateProps {
    username? : string,
    isLoggedIn : boolean
}

interface LoginComponentDispatchProps {
    signIn: () => void,
    signOut: () => void
}

interface LoginComponentProps extends LoginComponentStateProps, LoginComponentDispatchProps {
}

class LoginComponent extends React.Component<LoginComponentProps> {

    constructor(props: LoginComponentProps){
        super(props);

        this.onSignInClicked = this.onSignInClicked.bind(this);
        this.onSignOutClicked = this.onSignOutClicked.bind(this);
    }

    onSignInClicked(e : React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        e.preventDefault();
        this.props.signIn();
    }

    onSignOutClicked(e : React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        e.preventDefault();
        this.props.signOut();
    }

    render() {

        if (this.props.isLoggedIn) {
            return (
                <nav>
                    <a onClick={this.onSignOutClicked}>{this.props.username}</a>
                </nav>
            );
        } else {
            return (
                <nav>
                    <a onClick={this.onSignInClicked}>Sign In</a>
                </nav>
            );
        }
    }
}

const mapStateToProps = (state: AppState) : LoginComponentStateProps => {
    console.log("updateing props...");
    return {
        isLoggedIn: !!state.auth.username,
        username: state.auth.username
    }
}

const mapDispatchToProps = (dispatch: Dispatch<any>) : LoginComponentDispatchProps => {
    return {
        signIn: () => dispatch(thunkLogInWithPopup()),
        signOut: () => dispatch(thunkLogOut())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginComponent);